import { render, staticRenderFns } from "./StudentBanner.vue?vue&type=template&id=7a34f5e4&scoped=true&"
import script from "./StudentBanner.vue?vue&type=script&lang=js&"
export * from "./StudentBanner.vue?vue&type=script&lang=js&"
import style0 from "./StudentBanner.vue?vue&type=style&index=0&id=7a34f5e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a34f5e4",
  null
  
)

export default component.exports